export class IncidentCommentAddCommand {
    constructor(
        public readonly VarianceId: string,
        public readonly CommentText: string,
        public readonly AddedBy: string,
    ) {}
}